const defaultState = () => {
  return {
    all: [],
  };
};

const getters = {
  all: state => state.all,
};

const mutations = {
  set(state, userQuizzes) {
    state.all = userQuizzes;
  },
  reset(state) {
    Object.assign(state, defaultState());
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
};
